import {getLastViewedProducts, addLastViewedProduct} from "./carousel/last-viewed-storage";
import {renderLastViewedProductsBlock} from "./carousel/last-viewed-render";

export {addLastViewedProduct, getLastViewedProducts, renderLastViewedProductsBlock};
